module.exports = __webpack_public_path__ + "static/media/03.93f1c429.png";